<template>
    <div>
        <Toolbar>
            <BackButton :href="$route('subscriptions')"/>
        </Toolbar>

        <Card>
            <template v-slot:title>
                {{ customer ? customer.name : 'Unknown customer' }} {{ __('subscriptions.invoices') }}
            </template>
            <template v-slot:description>
                {{ __('actions.view_all_things', {things: __('subscriptions.invoices')}) }}
            </template>

            <table class="table table-hover">
                <thead>
                <tr>
                    <th>
                        {{ __('general.type') }}
                    </th>
                    <th class="text-right">
                        {{ __('subscriptions.invoicing.amount') }}
                    </th>
                    <th class="text-left pl-3">
                        {{ __('general.status') }}
                    </th>
                    <th>
                        {{ __('general.created') }}
                    </th>
                    <!--                    <th>-->
                    <!--                        {{ __('general.sent') }}-->
                    <!--                    </th>-->
                    <th class="text-right">
                        {{ __('general.actions') }}
                    </th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="invoice in paginatedInvoices.data">
                    <td>
                        {{ invoice.display_name }}
                    </td>
                    <td class="text-right">
                        <Price :value="invoice.total"/>
                    </td>
                    <td class="text-left pl-2">
                        <Badge v-if="invoice.status === 'paid'" type="badge-success" icon="fas fa-check">
                            {{ __('orders.paid') }}
                        </Badge>
                        <Badge v-else type="badge-secondary" icon="fas fa-times">
                            <span v-if="invoice.status === 'unpaid'">
                                {{ __('orders.payment.pending') }}
                            </span>
                            <span v-else>
                            {{ invoice.status.toUpperCase() }}
                            </span>
                        </Badge>
                    </td>
                    <td>
                        {{ $localDate(invoice.created_at) }}
                    </td>
                    <!--                    <td>-->
                    <!--                        <span v-if="invoice.sent_at">-->
                    <!--                            {{ $localDate(invoice.sent_at) }}-->
                    <!--                        </span>-->
                    <!--                        <span v-else>-->
                    <!--                            &dash;-->
                    <!--                        </span>-->
                    <!--                    </td>-->
                    <td class="text-right">
                        <Link as="button" class="btn btn-xs btn-secondary"
                              :href="$route('subscriptions.customers.invoices.show', [invoice.customer.uid, invoice.id])">
                            <i class="fas fa-eye"/>
                            {{ __('actions.view') }}
                        </Link>
                    </td>
                </tr>
                </tbody>
            </table>
        </Card>
    </div>
</template>

<script>
import Price from "@components/Price.vue";
import Badge from "@components/Badge.vue";
import { Link } from '@inertiajs/vue2';
import BackButton from "@components/BackButton.vue";
import Card from "@components/Cards/Card.vue";
import Toolbar from "@components/Toolbar.vue";
import WebsocketMixin from "@mixins/WebsocketMixin";

export default {
    components: {Toolbar, Card, BackButton, Badge, Price, Link},

    mixins: [WebsocketMixin],

    props: {
        paginatedInvoices: Object,
        customer: Object
    },

    mounted() {
        this.listenUser(this.customer.firebase_uid, 'invoice.updated', this.invoiceUpdated)
        this.listenUser(this.customer.firebase_uid, 'invoice.created', this.invoiceCreated)
    },

    methods: {
        invoiceUpdated(invoice) {
            for (let invoiceInTable of this.paginatedInvoices.data) {
                if (invoiceInTable.id === invoice.id) {
                    this.$inertia.reload({only: ['paginatedInvoices']})
                }
            }
        },

        invoiceCreated() {
            this.$inertia.reload({only: ['paginatedInvoices']})
        }
    }
}
</script>
